<template>
	<div class="">
		<div class="row">
			<div class="col-12">
				<ol class="breadcrumb ml-n3 mr-n3">
					<li class="breadcrumb-item">
						<a href="#">{{ GetList }}</a>
					</li>
					<li class="breadcrumb-item active"></li>
				</ol>
			</div>
		</div>

		<!-- Breadcrumbs -->
		<!--HEDER DE La LISTA--->
		<div class="row">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<slot name="contoleradicional"></slot>
				<div class="card card-darck">
					<div class="card-body">
						<form onsubmit="return false;" class="row">
							<div class="col-md-9 col-lg-9">
								<form class="form-inline">
									<div class="form-group mb-2">
										<label class="mr-3">Filtro</label>
										<div class="input-group">
											<input
												type="text"
												class="form-control"
												:title="pFiltro.placeHSearch"
												:placeholder="pFiltro.placeHSearch"
												v-model="pFiltro.valueSearch"
											/>
											<span class="input-group-btn">
												<button
													@click="busqueda"
													class="btn btn-01 btn-fil"
													type="button"
												>
													<i class="fa fa-search"></i>
												</button>
											</span>
										</div>
									</div>
									<div class="form-group mx-sm-3 mb-2">
										<label class="mr-3">Filas</label>
										<select
											@change="busqueda"
											v-model="pFiltro.entrada"
											class="form-control"
										>
											<option value="25">25</option>
											<option value="50">50</option>
											<option value="100">100</option>
										</select>
									</div>
									<slot name="filtroCombos"></slot>
								</form>
							</div>
							<div class="col-md-3 col-lg-3">
								<form class="form-inline justify-content-end">
									<button
										v-if="OList.showBackButton"
										@click="Regresar"
										type="button"
										class="btn btn-01 mb-3 mr-2"
									>
										<i class="fas fa-chevron-left"></i>
										{{ OList.nameBackButton }}
									</button>
									<template v-if="OList.showBtnNew">
										<span v-if="segurity.Save">
											<button
												v-if="OList.isModal"
												@click="nuevo(0)"
												type="button"
												class="btn btn-01 mb-3"
												data-toggle="modal"
												data-target="#ModalForm"
												data-backdrop="static"
												data-keyboard="false"
											>
												<i class="far fa-plus-circle"></i>
												{{ OList.titleBtnNew }}
											</button>
											<button
												v-else
												@click="nuevo(1)"
												type="button"
												class="btn btn-01 mb-3"
											>
												<i class="far fa-plus-circle"></i>
												{{ OList.titleBtnNew }}
											</button>
										</span>
									</template>
								</form>
							</div>
						</form>
						<!--Filtros-->

						<!--CUERPO DE La tabla--->
						<div class="table-responsive" id="datatab">
							<table class="table table-hover table-striped table-sm">
								<thead>
									<slot name="header"></slot>
								</thead>
								<tbody>
									<slot name="body"></slot>
									<slot name="botones"></slot>
								</tbody>
							</table>
						</div>

						<!--<Cpaginator :TotalItems="pFiltro.totalItems" :PageSize="pFiltro.pageSize"></Cpaginator>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Clist",
	props: ["pOList", "pFiltro", "segurity"],
	components: {
	},
	data() {
		return {
			OList: {
				title: "Listado",
				titleBtnNew: "Nuevo",
				showBtnNew: true,
				showBackButton: false,
				nameBackButton: "Regresar",
				isModal: true,
				Obj: {} //declara caulquier objeto para enviar al form
			}
			/*
            oFiltro:{
                placeHSearch:'Escribe para buscar',
                valueSearch:'',
                entrada:50,
                pag:1,
                totalItems:0,
                pageSize:0,
            }*/
		};
	},
	methods: {
		nuevo() {
			if (this.OList.isModal == true) {
				this.bus.$emit("NuevoModal", 0, this.OList.Obj);
			} else {
			}
		},
		Regresar() {
			this.bus.$emit("Regresar");
		},
		busqueda() {
			this.bus.$emit("List", this.pFiltro);
		}
	},
	created() {},
	computed: {
		GetList() {
			//#region VALIDACION PARA RECIBIR PROPS DE La Lista
			if (this.pOList != undefined) {
				if (this.pOList.title != undefined) {
					this.OList.title = this.pOList.title;
				}
				if (this.pOList.titleBtnNew != undefined) {
					this.OList.titleBtnNew = this.pOList.titleBtnNew;
				}
				if (this.pOList.showBtnNew != undefined) {
					this.OList.showBtnNew = this.pOList.showBtnNew;
				}
				if (this.pOList.showBackButton !== undefined) {
					this.OList.showBackButton = this.pOList.showBackButton;
				}
				if (this.pOList.nameBackButton !== undefined) {
					this.OList.nameBackButton = this.pOList.nameBackButton;
				}
				if (this.pOList.isModal != undefined) {
					this.OList.isModal = this.pOList.isModal;
				}
				if (this.pOList.entrada != undefined) {
					this.OList.entrada = this.pOList.entrada;
				}
			}

			//#region VALIDACION PARA RECIBIR PROPS DE LOS FILTROS
			/*if(this.pFiltro!=undefined){
                if(this.pFiltro.placeHSearch!=undefined){this.oFiltro.placeHSearch=this.pFiltro.placeHSearch;}
                if(this.pFiltro.valueSearch!=undefined){this.oFiltro.valueSearch=this.pFiltro.valueSearch;}
                if(this.pFiltro.entrada!=undefined){this.oFiltro.entrada=this.pFiltro.entrada;}
                if(this.pFiltro.pag!=undefined){this.oFiltro.pag=this.pFiltro.pag;}
                if(this.pFiltro.totalItems!=undefined){this.oFiltro.totalItems=this.pFiltro.totalItems;}
                if(this.pFiltro.pageSize!=undefined){this.oFiltro.pageSize=this.pFiltro.pageSize;}
            }*/

			return this.OList.title;
		}
	}
};
</script>
